//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import User from '~/components/User.vue';
import Pagination from '~/components/Pagination.vue';
import constant from '~/const';

import tableConfig from './tableConfig';

export default {
  components: { Pagination, User },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('statisticsRequisiteUser', ['data', 'page', 'pages']),

  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('statisticsRequisiteUser', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
      deleteRelationAction: 'deleteRelation',
    }),

    async applyFilters() {
      try {
        this.setGeneralLoader(true);
        await this.loadDataAction();
        this.setGeneralLoader(false);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
    },

    handleDeleteClick(id) {
      this.confirmAction({
        title: 'Are you sure, you want to delete this relation?',
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.deleteRelationAction(id);
            await this.loadDataAction();
            this.setSuccessNotification('You have successfuly deleted this relation');
          } catch (error) {
            this.setErrorNotification(error.message);
          } finally {
            this.setGeneralLoader(false);
          }
        },
      });
    },

    setPage(value) {
      this.setPageAction(value);
      this.loadDataAction();
    },
  },
};
